<template>
  <div>
    <!-- login -->
    <div class="weui-mask" v-show="isShowLogin">
      <div id="login_container" class="login-panel">
        <div class="left-right-margin center relative-top-primary">
          <img src="../assets/icon_rounded_256.png" class="login-icon">
          <p>登录易退税发现更多</p>

          <div class="weui-cells">
            <div class="weui-cell weui-cell_select weui-cell_select-before">
              <div class="weui-cell__hd">
                <select class="weui-select" name="select2" v-model="accountType">
                  <option value="telephone">手机</option>
                  <option value="email">邮箱</option>
                </select>
              </div>
              <div class="weui-cell__bd" v-show="accountType == 'telephone'">
                <select class="weui-select" id="select-code" name="select2" v-model="code">
                  <option :value="entry.value" v-for="entry in telCodes">{{entry.text}}</option>
                </select>
              </div>
            </div>

            <div class="weui-cell" v-show="accountType == 'telephone'">
              <div class="weui-cell__hd"><label class="weui-label">号码</label></div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="number" pattern="[0-9]*" v-model="params.telephone" placeholder="请输入号码"/>
              </div>
            </div>

            <div class="weui-cell" v-show="accountType == 'email'">
              <div class="weui-cell__hd"><label class="weui-label">邮箱</label></div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="email" v-model="params.email" placeholder="请输入邮箱"/>
              </div>
            </div>

            <div class="weui-cell">
              <div class="weui-cell__hd"><label class="weui-label">密码</label></div>
              <div class="weui-cell__bd">
                <input class="weui-input" type="password" v-model="params.password" placeholder="请输入密码"/>
              </div>
            </div>
          </div>

          <a href="javascript:;" class="weui-btn weui-btn_primary margin-top-thirdly" @click="login">登录</a>
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="hide">随便逛逛</a>
          <div class="weui-cells__tips margin-top-secondly">-或使用第三方登录-</div>

          <div class="margin-top-thirdly">
            <div class="center">
              <a class="primary" v-bind:href="WxLoginLink">
                微信内登录
              </a>
            </div>
            <div class="center margin-top-fourthly"><a class="primary" href="javascript:;" @click="wxLogin">微信外扫码登录</a></div>
            <div class="margin-top-fourthly">
              <!--<div id="wb_connect_btn">微博登陆请在浏览器中打开或下载易退税应用</div>-->
            </div>
            <!--<div class="center margin-top-fourthly"><a class="primary" href="javascript:;" v-bind:href="weiboLoginLink">微博</a></div>-->
          </div>

          <div class="weui-footer footer margin-top-primary">
            <p class="weui-footer__links">
              <a href="javascript:void(0);" class="weui-footer__link" @click="terms">用户协议</a>
              <a href="javascript:void(0);" class="weui-footer__link" @click="terms">隐私政策</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2016 小幕（北京）科技有限公司</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../service/api.js'
  import utils from '../utils/common.js'
  import WxLogin from '../service/wxLogin'
  import errorHandler from '../error/errorHandler'

  export default {
    name: 'login',

    methods: {
      wxLogin () {
        WxLogin(
          {
            id: 'login_container',
            appid: 'wx47ecc77b53225372',
            scope: 'snsapi_login',
            redirect_uri: 'http%3A%2F%2Fm.yituishui.com',
            state: '1',
            style: '',
            href: ''
          }
        , document)
      },

      login () {
        let th = this

        // show loading
        this.$store.commit('setIsShowLoading', {
          isShowLoading: true,
          loadingText: '登录中'
        })

        let args = {
          password: th.params.password
        }

        if (th.accountType === 'telephone') {
          args.telephone = th.code + th.params.telephone
        } else {
          args.email = th.params.email
        }

        api.post(
          'auth/login',
          args
        ).then(function (response) {
          // hide loading
          th.$store.commit('setIsShowLoading', {
            isShowLoading: false
          })

          th.$store.dispatch('setUserInfo', response.data)
          window.window.sessionStorage.user = JSON.stringify(response.data) // 解决刷新后登录状态问题

          th.hide()
        })
        .catch(function (error) {
          th.$store.commit('setIsShowLoading', {
            isShowLoading: false
          })
          th.$store.commit('setIsShowDialog', {
            isShowDialog: true,
            dialogTitle: '登录出错',
            dialogContent: '用户名或密码错误'
          })
          errorHandler(error)
        })
      },

      hide () {
        this.$store.commit('setShowLogin', false)
      },

      terms () {
        window.location = 'https://www.yituishui.com/application/terms'
      }
    },

    computed: {
      isLogin () {
        return !utils.isEmptyObject(this.$store.getters.getUserInfo)
      },
      isShowLogin () {
        return this.$store.getters.getIsShowLogin
      },
      WxLoginLink () {
        let link = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
        link += 'appid=wx47ecc77b53225372&'
        link += 'redirect_uri=http%3A%2F%2Fm.yituishui.com&'
        link += 'response_type=code&'
        link += 'scope=snsapi_login&'
        link += 'state=1#wechat_redirect'
        return link
      },
      weiboLoginLink () {
        let link = 'https://api.weibo.com/oauth2/authorize?'
        link += 'client_id=937571124&'
        link += 'response_type=code&'
        link += 'redirect_uri=https%3A%2F%2Fwww.yituishui.com%2Fh5%2Findex.html'
        return link
      }
    },

    watch: {
      accountType (newAccountType) {
        if (this.accountType === 'telephone') {
          this.params.email = ''
        } else {
          this.params.telephone = ''
        }
      },

      isShowLogin (newIsShowLogin) {
        if (newIsShowLogin) {
          // renew login state
          this.$store.commit('setWxLoginState', utils.randomString(16))
        }
      }
    },

    data () {
      return {
        accountType: 'telephone',

        params: {
          telephone: '',
          email: '',
          password: ''
        },

        code: '+86',

        telCodes: [
          {
            text: '中国+86',
            value: '+86'
          },
          {
            text: '德国+49',
            value: '+49'
          }
        ]
      }
    }
  }
</script>

<style lang="stylus">
  @import '../style/base.css'
  .login-panel
    background: #fff
    height 100%
    overflow-y scroll
  .login-icon
    width: 100px
  #select-code
    width 150px
</style>



// WEBPACK FOOTER //
// Login.vue?70796de8